export default __webpack_public_path__ + "static/media/plus.05bec45c.svg";